import { Box, FormControl, MenuItem, TextField } from "@mui/material";
import { useState } from "react";
import { useIntl } from "react-intl";
import Messages from "../../localization/Messages";
import { useFetchDestinations } from "../../hooks/useFetchDestinations";
import PortDocumentsViewer from "../../components/PortDocumentsViewer/PortDocumentsViewer";
import RpisPage from "../RpisPage/RpisPage";

/**
 * Locks &amp; Docks Port Information page.
 *
 * Lets the user pick a destination and view the read-only port information
 * (documents and/or weblinks) published by the Dispatcher.
 */
export const LDPortInformation = () => {
    const intl = useIntl();
    const destinations = useFetchDestinations();
    const [destinationId, setDestinationId] = useState("");

    return (
        <RpisPage title={intl.formatMessage(Messages.portInformation)}>
            <Box p={2}>
                <FormControl sx={{ minWidth: 320, mb: 2 }}>
                    <TextField
                        select
                        label={intl.formatMessage(Messages.destination)}
                        value={destinationId}
                        onChange={e => setDestinationId(e.target.value)}
                        variant="filled"
                    >
                        {destinations.map(d => (
                            <MenuItem key={d.id} value={d.id}>
                                {d.name}
                            </MenuItem>
                        ))}
                    </TextField>
                </FormControl>
                <PortDocumentsViewer
                    destinationId={destinationId}
                    emptyState={intl.formatMessage(Messages.destination) + " ..."}
                />
            </Box>
        </RpisPage>
    );
};

export default LDPortInformation;
